// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.DeleteModal_dashboard__VuWC- {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.DeleteModal_dashboardContain__u6PV5 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_dashboardContain__u6PV5,
.DeleteModal_bodythemedark__\\+j06m .DeleteModal_dashboard__VuWC-,
.DeleteModal_bodythemedark__\\+j06m .DeleteModal_cont2__KIGjc {
  background-Color: #0f1824;
}

.DeleteModal_top_header__buyJx .DeleteModal_top_header_inner__HkgQ2 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.DeleteModal_cont2__KIGjc {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.DeleteModal_subLink__cWiWp svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.DeleteModal_footer__i9lwr {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.DeleteModal_bodythemelight__KlgHH {
  background-color: #fff;
  padding-top: 90px;
}

.DeleteModal_bodythemedark__\\+j06m {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.DeleteModal_headerthemelight__klH04 {
  background-color: #fff;
}

.DeleteModal_headerthemedark__67zL- {
  background-color: #132337;
}

.DeleteModal_top_header__buyJx {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.DeleteModal_menuthemelight__-s0n6 {
  background-color: #fff;
}

.DeleteModal_menuthemedark__24owU {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.DeleteModal_menulinklight__rMPzK span {
  color: #666666 !important;
}

.DeleteModal_menulinklight__rMPzK a {
  color: #CBCBCB !important;
}

.DeleteModal_menulinklight__rMPzK:hover span, .DeleteModal_menulinklight__rMPzK:hover a {
  color: #fff !important;
}

.DeleteModal_menulinkdarkSelected__b8UKB {
  background-color: #1c2e45;
  color: #fff;
}

.DeleteModal_menuthemelight__-s0n6 .DeleteModal_menulinklightSelected__\\+3Y2- {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.DeleteModal_menulinkdark__v2oCq {
  color: #60677e !important;
}

.DeleteModal_menulinklight__rMPzK:hover {
  color: #fff !important;
  background-color: #205440;
}

.DeleteModal_menulinkdark__v2oCq:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.DeleteModal_headinglight__rPrZ7 {
  color: #60677e;
}

.DeleteModal_headingdark__pm5mN {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.DeleteModal_searchboxlight__XRa5N {
  background-color: #fff;
  border: none;
}

.DeleteModal_searchboxdark__UxCGS {
  background-color: #132337;
  color: #fff;
  border: none;
}

.DeleteModal_searchboxdark__UxCGS::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.DeleteModal_tableheadlight__wAr-W {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.DeleteModal_tableheadlight__wAr-W th {
  color: #fff;
}

thead .DeleteModal_tableheadlight__wAr-W th:first-child,
thead .DeleteModal_tableheaddark__L-bWe th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .DeleteModal_tableheadlight__wAr-W th:last-child,
thead .DeleteModal_tableheaddark__L-bWe th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.DeleteModal_table__-lfAe.DeleteModal_table-borderless__r3cpt {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.DeleteModal_tableheaddark__L-bWe {
  background-color: #1e1e2d;
  color: #fff;
}

.DeleteModal_table-borderless__r3cpt tr:nth-child(even) {
  background-color: #F9FAFB;
}

.DeleteModal_table-borderless__r3cpt .DeleteModal_left-section__kTDei {
  padding-top: 10px;
}

.DeleteModal_tablebodylight__6Ai9y td,
.DeleteModal_tablebodydark__3e1cB td {
  padding: 1rem 1rem !important;
}

.DeleteModal_tablebodylight__6Ai9y {
  background-color: #fff;
}
.DeleteModal_tablebodylight__6Ai9y:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.DeleteModal_tablebodydark__3e1cB {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.DeleteModal_tablebodydark__3e1cB:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.DeleteModal_paginationlight__o948\\+ {
  color: #60677e !important;
  font-size: 13px !important;
}

.DeleteModal_paginationdark__O4Vsl {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.DeleteModal_formthemelight__jqrbK {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.DeleteModal_formthemedark__GYW8e {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.DeleteModal_formthemedark__GYW8e ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.DeleteModal_viewformlight__YPo4- {
  background-color: #f3f6f9;
}

.DeleteModal_permissionboxlight__GnNaj {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.DeleteModal_permissionboxdark__agi1K {
  background-color: #151521;
  border: solid 1px #242434;
}

.DeleteModal_errormsgclr__nk3-l {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.DeleteModal_graphclrlight__fXv3r {
  background-color: #fff;
}

.DeleteModal_graphclrdark__JmECA {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#DeleteModal_card1bglight__dYlvA {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card1bglight__dYlvA:hover {
  background: #f7fffc;
}

#DeleteModal_card1bgdark__Q2hjw {
  background: #392f28;
}

#DeleteModal_card1bgdark__Q2hjw:hover {
  background: #f7fffc;
}

#DeleteModal_card2bglight__N7FlO {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card2bglight__N7FlO:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#DeleteModal_card2bgdark__jUld4 {
  background: #1c3238;
}

#DeleteModal_card3bglight__sPu6M {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card3bglight__sPu6M:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#DeleteModal_card3bgdark__rKcHN {
  background: #3a2434;
}

#DeleteModal_card4bglight__xxtQf {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#DeleteModal_card4bglight__xxtQf:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#DeleteModal_card4bgdark__1hk4w {
  background: #2f264f;
}

#DeleteModal_card1bgdark__Q2hjw a, #DeleteModal_card1bgdark__Q2hjw p,
#DeleteModal_card2bgdark__jUld4 a, #DeleteModal_card2bgdark__jUld4 p,
#DeleteModal_card3bgdark__rKcHN a, #DeleteModal_card3bgdark__rKcHN p,
#DeleteModal_card4bgdark__1hk4w a, #DeleteModal_card4bgdark__1hk4w p {
  color: #fff;
}

/* 
Action button theme
*/
.DeleteModal_actionbtnlight__bn4Nx {
  color: rgba(70, 71, 91, 0.8705882353);
}

.DeleteModal_actionbtndark__SYWtn {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.DeleteModal_profiledropdownlight__cjL9G {
  background-color: #fff;
}

.DeleteModal_profiledropdowndark__TEpvq {
  background-color: #151521;
}

.DeleteModal_settingsection__5q9Ua #DeleteModal_addform__xPmsX.DeleteModal_formthemedark__GYW8e .DeleteModal_savebtn__wghFI {
  background-color: #0a2574;
  color: #fff;
}

#DeleteModal_addform__xPmsX.DeleteModal_formthemedark__GYW8e .DeleteModal_savebtn__wghFI {
  background-color: #0a2574;
  color: #fff;
}

.DeleteModal_profile_conatiner__dXlZG {
  border-radius: 5px !important;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_ag-theme-alpine__i9ugX .DeleteModal_ag-row__i2M41 {
  background: #000 !important;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_formbtn__pdyV8 {
  background-color: #0a2574;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_resetbtn__GYl7s {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_resetbtn__GYl7s:hover {
  background-color: #0a2574;
}

.DeleteModal_headingdark__pm5mN span {
  background-color: #132337;
}

.DeleteModal_resetbtn__GYl7s {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.DeleteModal_resetbtn__GYl7s:hover,
.DeleteModal_resetbtn__GYl7s:active,
.DeleteModal_resetbtn__GYl7s:focus {
  background-color: #205440;
  color: #fff;
}

.DeleteModal_addBtn__mw15J {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.DeleteModal_addBtn__mw15J svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.DeleteModal_addBtn__mw15J:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.DeleteModal_cust_addBtn__J0PRE.DeleteModal_addBtn__mw15J svg {
  top: 2px;
}

.DeleteModal_deleteBtn__FbiXC {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.DeleteModal_deleteBtn__FbiXC {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.DeleteModal_deleteBtn__FbiXC:active, .DeleteModal_deleteBtn__FbiXC:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.DeleteModal_deleteBtn__FbiXC svg {
  position: relative;
  top: -2px;
}

.DeleteModal_deleteBtn__FbiXC:hover,
.DeleteModal_deleteBtn__FbiXC:active,
.DeleteModal_deleteBtn__FbiXC:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.DeleteModal_confirmBtn__gQQu6 {
  background-color: #205440;
}

.DeleteModal_confirmBtn__gQQu6:hover,
.DeleteModal_confirmBtn__gQQu6:active,
.DeleteModal_confirmBtn__gQQu6:focus {
  background-color: #205440;
}

.DeleteModal_confirmBtn__gQQu6 svg {
  top: 0;
}

.DeleteModal_back_dlt__i6EIX {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.DeleteModal_delPopContainer__kh1eQ .DeleteModal_modal-body__4WUNx {
  padding: 25px;
  text-align: center;
}

.DeleteModal_delPopContainer__kh1eQ .DeleteModal_delet_icon__EasKH {
  margin-bottom: 11px;
}

.DeleteModal_delPopContainer__kh1eQ p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.DeleteModal_arrowback__Ghk3Y svg {
  fill: #000;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_arrowback__Ghk3Y {
  background-color: #0a2574;
  color: #fff;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_arrowback__Ghk3Y svg {
  fill: #fff;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_drpdwn_btn__zZW\\+u {
  background-color: #132337;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_empname__MSWvd {
  color: #60677e !important;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_navitemli__Z20gi a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_tabnavli__8mk8t a.DeleteModal_settingsgeneral__Dh27T,
.DeleteModal_bodythemedark__\\+j06m .DeleteModal_tabnavli__8mk8t a.DeleteModal_settingslinks__6nt8Q:hover {
  background-color: #0a2574;
  color: #fff;
}

.DeleteModal_bodythemedark__\\+j06m .DeleteModal_tabnavli__8mk8t a.DeleteModal_settingslinks__6nt8Q {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .DeleteModal_tableheadlight__wAr-W th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .DeleteModal_dashboard__VuWC- {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #DeleteModal_dashboardcont2__qo6XS {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .DeleteModal_sectionright__SrAvI {
    float: unset !important;
  }
  .DeleteModal_dashboard__VuWC- {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .DeleteModal_cont2__KIGjc {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .DeleteModal_bodythemelight__KlgHH, .DeleteModal_bodythemedark__\\+j06m {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .DeleteModal_exer_modal_contain__oga9o .DeleteModal_modal-dialog__pY6LO {
    max-width: 1055px;
  }
  .DeleteModal_delPopContainer__kh1eQ .DeleteModal_modal-dialog__pY6LO {
    max-width: 350px;
  }
}
.DeleteModal_resetbtn__GYl7s {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent !important;
  border: solid 1px #205440 !important;
  color: #205440 !important;
  min-width: 113px;
  min-height: 50px;
  margin-right: 24px;
}

.DeleteModal_resetbtn__GYl7s svg {
  margin-right: 10px;
  position: relative;
  top: -1px;
}

.DeleteModal_deleteBtn__FbiXC svg {
  margin-right: 10px;
}

@media only screen and (max-width: 360px) {
  .DeleteModal_resetbtn__GYl7s {
    min-width: 100px;
    margin-right: 15px;
  }
  .DeleteModal_deleteBtn__FbiXC {
    min-width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/DeleteModal/DeleteModal.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAlpBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAopBJ;;AAjpBA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AAopBJ;;AAhpBA;EACI,kBAAA;AAmpBJ;;AAhpBA;EACI;IACI,gBAAA;IACA,kBAAA;EAmpBN;EAjpBE;IACI,gBAAA;EAmpBN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.resetbtn {\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    background-color: transparent !important;\n    border: solid 1px $primary-color !important;\n    color: $primary-color !important;\n    min-width: 113px;\n    min-height: 50px;\n    margin-right: 24px;\n}\n\n.resetbtn svg {\n    margin-right: 10px;\n    position: relative;\n    top: -1px;\n}\n\n\n.deleteBtn svg {\n    margin-right: 10px;\n}\n\n@media only screen and (max-width: 360px) {\n    .resetbtn {\n        min-width: 100px;\n        margin-right: 15px;\n    }\n    .deleteBtn {\n        min-width: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `DeleteModal_dashboard__VuWC-`,
	"dashboardContain": `DeleteModal_dashboardContain__u6PV5`,
	"bodythemedark": `DeleteModal_bodythemedark__+j06m`,
	"cont2": `DeleteModal_cont2__KIGjc`,
	"top_header": `DeleteModal_top_header__buyJx`,
	"top_header_inner": `DeleteModal_top_header_inner__HkgQ2`,
	"subLink": `DeleteModal_subLink__cWiWp`,
	"footer": `DeleteModal_footer__i9lwr`,
	"bodythemelight": `DeleteModal_bodythemelight__KlgHH`,
	"headerthemelight": `DeleteModal_headerthemelight__klH04`,
	"headerthemedark": `DeleteModal_headerthemedark__67zL-`,
	"menuthemelight": `DeleteModal_menuthemelight__-s0n6`,
	"menuthemedark": `DeleteModal_menuthemedark__24owU`,
	"menulinklight": `DeleteModal_menulinklight__rMPzK`,
	"menulinkdarkSelected": `DeleteModal_menulinkdarkSelected__b8UKB`,
	"menulinklightSelected": `DeleteModal_menulinklightSelected__+3Y2-`,
	"menulinkdark": `DeleteModal_menulinkdark__v2oCq`,
	"headinglight": `DeleteModal_headinglight__rPrZ7`,
	"headingdark": `DeleteModal_headingdark__pm5mN`,
	"searchboxlight": `DeleteModal_searchboxlight__XRa5N`,
	"searchboxdark": `DeleteModal_searchboxdark__UxCGS`,
	"tableheadlight": `DeleteModal_tableheadlight__wAr-W`,
	"tableheaddark": `DeleteModal_tableheaddark__L-bWe`,
	"table": `DeleteModal_table__-lfAe`,
	"table-borderless": `DeleteModal_table-borderless__r3cpt`,
	"left-section": `DeleteModal_left-section__kTDei`,
	"tablebodylight": `DeleteModal_tablebodylight__6Ai9y`,
	"tablebodydark": `DeleteModal_tablebodydark__3e1cB`,
	"paginationlight": `DeleteModal_paginationlight__o948+`,
	"paginationdark": `DeleteModal_paginationdark__O4Vsl`,
	"formthemelight": `DeleteModal_formthemelight__jqrbK`,
	"formthemedark": `DeleteModal_formthemedark__GYW8e`,
	"viewformlight": `DeleteModal_viewformlight__YPo4-`,
	"permissionboxlight": `DeleteModal_permissionboxlight__GnNaj`,
	"permissionboxdark": `DeleteModal_permissionboxdark__agi1K`,
	"errormsgclr": `DeleteModal_errormsgclr__nk3-l`,
	"graphclrlight": `DeleteModal_graphclrlight__fXv3r`,
	"graphclrdark": `DeleteModal_graphclrdark__JmECA`,
	"card1bglight": `DeleteModal_card1bglight__dYlvA`,
	"card1bgdark": `DeleteModal_card1bgdark__Q2hjw`,
	"card2bglight": `DeleteModal_card2bglight__N7FlO`,
	"card2bgdark": `DeleteModal_card2bgdark__jUld4`,
	"card3bglight": `DeleteModal_card3bglight__sPu6M`,
	"card3bgdark": `DeleteModal_card3bgdark__rKcHN`,
	"card4bglight": `DeleteModal_card4bglight__xxtQf`,
	"card4bgdark": `DeleteModal_card4bgdark__1hk4w`,
	"actionbtnlight": `DeleteModal_actionbtnlight__bn4Nx`,
	"actionbtndark": `DeleteModal_actionbtndark__SYWtn`,
	"profiledropdownlight": `DeleteModal_profiledropdownlight__cjL9G`,
	"profiledropdowndark": `DeleteModal_profiledropdowndark__TEpvq`,
	"settingsection": `DeleteModal_settingsection__5q9Ua`,
	"addform": `DeleteModal_addform__xPmsX`,
	"savebtn": `DeleteModal_savebtn__wghFI`,
	"profile_conatiner": `DeleteModal_profile_conatiner__dXlZG`,
	"ag-theme-alpine": `DeleteModal_ag-theme-alpine__i9ugX`,
	"ag-row": `DeleteModal_ag-row__i2M41`,
	"formbtn": `DeleteModal_formbtn__pdyV8`,
	"resetbtn": `DeleteModal_resetbtn__GYl7s`,
	"addBtn": `DeleteModal_addBtn__mw15J`,
	"cust_addBtn": `DeleteModal_cust_addBtn__J0PRE`,
	"deleteBtn": `DeleteModal_deleteBtn__FbiXC`,
	"confirmBtn": `DeleteModal_confirmBtn__gQQu6`,
	"back_dlt": `DeleteModal_back_dlt__i6EIX`,
	"delPopContainer": `DeleteModal_delPopContainer__kh1eQ`,
	"modal-body": `DeleteModal_modal-body__4WUNx`,
	"delet_icon": `DeleteModal_delet_icon__EasKH`,
	"arrowback": `DeleteModal_arrowback__Ghk3Y`,
	"drpdwn_btn": `DeleteModal_drpdwn_btn__zZW+u`,
	"empname": `DeleteModal_empname__MSWvd`,
	"navitemli": `DeleteModal_navitemli__Z20gi`,
	"tabnavli": `DeleteModal_tabnavli__8mk8t`,
	"settingsgeneral": `DeleteModal_settingsgeneral__Dh27T`,
	"settingslinks": `DeleteModal_settingslinks__6nt8Q`,
	"dashboardcont2": `DeleteModal_dashboardcont2__qo6XS`,
	"sectionright": `DeleteModal_sectionright__SrAvI`,
	"exer_modal_contain": `DeleteModal_exer_modal_contain__oga9o`,
	"modal-dialog": `DeleteModal_modal-dialog__pY6LO`
};
export default ___CSS_LOADER_EXPORT___;
